import { FAQ_QUESTIONS_PATH, PCS_TAXONOMY_PATH } from "./data/faqs/paths";

/**
 * Convert a Storyblok CMS path like `/next/questions/slug` or translation urls like `ne-xt/next/questions/slug`
 * into `/ne-xt/energydrink/questions/slug`
 */
export const convertSbPathToUrl = (
  localeString: string,
  route: string,
): string => {
  const match =
    /\/?(questions|energydrink\/qa-taxonomy|energydrink|crh\/contact-taxonomy|crh|company)\/?(?<subpath>.*)$/.exec(
      route,
    );

  if (!match) {
    throw new Error(`Couldn't find subpath from route: ${route}`);
  }

  const remainingUrl = match.groups?.subpath || "";
  const pathType = match[1];

  switch (pathType) {
    case FAQ_QUESTIONS_PATH:
      return `/${localeString}/energydrink/questions/${remainingUrl}`;
    case PCS_TAXONOMY_PATH:
      return `/${localeString}/energydrink/questions/${remainingUrl}`;
    case "energydrink":
      return `/${localeString}/energydrink/${remainingUrl}`;
    case "crh/contact-taxonomy":
      return `/${localeString}/support-hub/${remainingUrl}`;
    case "crh":
      return `/${localeString}/support-hub/${remainingUrl}`;
    case "company":
      return `/${localeString}/company/${remainingUrl}`;
    default:
      return `/${localeString}/energydrink/${remainingUrl}`;
  }
};

/**
 * Extract the last segment from a URL path.
 * For example: `/ch-fr/support-hub/interest-group` -> `interest-group`
 * Currently used in CRH to get the translated slug from the `full_slug`
 */
export const getLastSegmentFromUrl = (url: string): string => {
  const segments = url.replace(/^\/+|\/+$/g, "").split("/");
  return segments[segments.length - 1] || "";
};
